<div class="white">
    <div class="container mb-6">
        <div class="row">
            <div class="col-12">
                <div class="gb-body2">{{includeCancelFAQLink ? wantToCancel : ('my_plans_cancel_service_title' | translate)}}</div>
                <p class="gb-body3 mb-6">
                    <span [translate]="'my_plans_cancel_service_info'" class="pr-1"></span>
                    <a href="{{'my_plans_cancel_service_phoneLink' | translate}}" [translate]="'my_plans_cancel_service_phoneNum'" 
                        trackLink="call"
                        trackType="o"
                        prop15="call"
                        [prop10]="trackingString('link', ['change or cancel service', 'call'])"
                        [evar33]="trackingString('link', ['change or cancel service', 'call'])"></a>
                    @if (includeCancelFAQLink) {
                        <span [translate]="'my_plans_cancel_service_callsMonitored'" class="pr-1"></span>
                        <a href="{{'my_plans_cancel_service_link' | translate}}" 
                            [translate]="'my_plans_cancel_service_linkText'" [translateParams]="{make: make}"   
                            trackLink="how to"
                            trackType="o"
                            prop15="how to"
                            [prop10]="trackingString('link', ['change or cancel service', 'how to'])"
                            [evar33]="trackingString('link', ['change or cancel service', 'how to'])"></a>
                    }
                    @else {
                        &nbsp;<span [translate]="'my_plans_cancel_service_speak_to_advisor'" class="pr-1"></span>
                    }
                </p>
            </div>
        </div>
    </div>
</div>